(function($, undefined) {
	
	'use strict';
	var formAnimate;
	var formValidator;
	var tools;
	var win;
	var formBtn;
	var formCtn;
	var consignesRecapCtn;
	var consignesRecapCtnHeight;
	var consignesRecapOuterCtn;
	var consignesRecapOuterCtnTop;
	var consignesRecapOuterCtnHeight;
	var showTicketCatsBtn;
	var showTicketCatsBtnResp;
	var ticketChoiceCheck;
	var cartRecap;
	var consignesQtyCtn;
	var deleteTicketChoiceBtn;
	var qtyInput;
	var shippingMode;
	var confirmOrderBtn;
	var showTicketsDetailBtn;
	var printConsigneTicketsBtn;

	var checkScroll = function() {
		consignesRecapCtnHeight = consignesRecapCtn.height();
		consignesRecapOuterCtnTop = consignesRecapOuterCtn.offset().top - $('.site-header').height();
		consignesRecapOuterCtnHeight = consignesRecapOuterCtn.height();
		var maxBottom = ((consignesRecapOuterCtnHeight + consignesRecapOuterCtnTop) - consignesRecapCtnHeight);

		if (win.scrollTop() > maxBottom) {
			$('.consignes-recap-outer-ctn.absolute').css('top', (consignesRecapOuterCtnHeight - consignesRecapCtnHeight) + 'px');
		} else if (win.scrollTop() > consignesRecapOuterCtnTop && !(win.scrollTop() > maxBottom)) {
			$('.consignes-recap-outer-ctn.absolute').css('top', (win.scrollTop() - consignesRecapOuterCtnTop) + 'px');
		} else if (win.scrollTop() <= consignesRecapOuterCtnTop) {
			$('.consignes-recap-outer-ctn.absolute').css('top', '0px');
		}
	};

	var showTicketCats = function() {
		var t = $(this);
		var parentTd = t.closest('td');
		var parentTr = t.closest('tr');

		parentTd.toggleClass('open');
		parentTr.next('.consigne-table-tickets-cats').slideToggle();
	};

	var ticketToQtyBox = function() {
		var t = $(this);
		var id = t.attr('id');
		var ticketsBox = $('.consignes-tickets-ctn');
		var qtyBox = $('.consignes-qty-box');
		var qtyBoxInnerCtn = $('.consignes-qty-tickets-outer-ctn', qtyBox);
		var currItem = qtyBox.find('.tickets-list-one-ticket-ctn[data-id=' + id + ']');
		
		if (currItem.length) {
			currItem.remove();
			addToCart(id, 0);
		} else {
			var ctn = t.closest('.tickets-list-one-ticket-content');
			var eventName = t.closest('.tickets-list-outer-ctn').find('.tickets-list-header').html();
			var name = ctn.find('.name').html();
			var price = ctn.find('.price').html();
			var max = ctn.attr('data-max');
			var ticketClone = qtyBox.find('.event-folders-ticket-temp.hide').clone();
			var deleteTicketChoiceBtn = ticketClone.find('.delete-btn');
			var qtyInput = ticketClone.find('.form-input');

			ticketClone.find('.tickets-list-one-ticket-ctn').attr('data-id', id);
			ticketClone.find('.name').html(eventName + ' - ' + name);
			ticketClone.find('.price').html(price);
			qtyBoxInnerCtn.append(ticketClone.children());
			tools.init();
			formAnimate.init();
			qtyBoxInnerCtn.addClass('filled');
			addToCart(id, 1);
	
			deleteTicketChoiceBtn.click(deleteTicket);

			qtyInput.attr('max', max);
			qtyInput.keyup(checkQtyMax);
			qtyInput.focusout(updateQty);
		}

		if (qtyBoxInnerCtn.children().length === 0) {
			qtyBoxInnerCtn.removeClass('filled');
		}
	};

	var deleteTicket = function() {
		var ticketsBox = $('.consignes-tickets-ctn');
		var id = $(this).closest('.tickets-list-one-ticket-ctn').attr('data-id');
		ticketsBox.find('.package-ticket-choice[id=' + id + ']').trigger('click');
		addToCart(id, 0);
	};

	var updateQty = function() {
		var id = $(this).closest('.tickets-list-one-ticket-ctn').attr('data-id');
		
		addToCart(id, $(this).val());
	};

	var checkQtyMax = function() {
		if (parseInt($(this).val()) > parseInt($(this).attr('max'))) {
			$(this).val($(this).attr('max'));
		}
	};

	var addToCart = function(id, qty) {
		var url = '/action/epAddCart?ajax=true&consigne';
		url += '&ticketId=' + id;
        
		ajax(url + '&remove=true', function(response) {
			if (response.indexOf('success') !== -1) {
				if (qty !== 0) {
					ajax(url + '&quantity=' + qty, function(response) {
						if (response.indexOf('success') !== -1) {
							updateRecap();
						}
					}, true);
				} else {
					updateRecap(id, qty);
				}
			}
		}, true);
	};

	var updateRecap = function(id, qty) {
		var url = '/action/epJsonCart?consigne=true';

		if (qty === 0 && cartRecap.find('.consignes-recap-one-item[id=' + id + ']').length) {
			cartRecap.find('.consignes-recap-one-item[id=' + id + ']').remove();
		}

		ajax(url, function(response){
			var json = JSON.parse(response.trim());

			$.each(json, function(k, v) {
				if (json[k].id) {
					var item;

					if (cartRecap.find('.consignes-recap-one-item[id=' + json[k].id + ']').length) {
						item = cartRecap.find('.consignes-recap-one-item[id=' + json[k].id + ']');
					} else {
						item = $('.consignes-recap-one-item-outer-ctn.hide').clone();
					}

					item.find('.consignes-recap-item-name').html(encodeText(json[k].name));
					item.find('.consignes-recap-one-item').attr('id', json[k].id);
					item.find('.consignes-recap-item-price .amount').html(json[k].subPrice);
					item.find('.consignes-recap-item-qty').html(json[k].quantity);

					if (item.hasClass('hide')) {
						$('.consignes-recap-items-ctn').append(item.children());
					}
				} else {
					if (json[k].tickets === '0') {
						$('.consignes-recap-outer-ctn.absolute').fadeOut();
					} else {
						$('.consignes-recap-outer-ctn.absolute').fadeIn();
					}

					cartRecap.find('.recap-total.shipping-fees').html(json[k].shipping);
					cartRecap.find('.recap-total.subtotal').html(json[k].subTotalTickets);
					cartRecap.find('.recap-total.tps').html(json[k].tps);
					cartRecap.find('.recap-total.tvq').html(json[k].tvq);
					cartRecap.find('.recap-total.total').html(json[k].totalPriceTickets);
				}
			});

			consignesQtyCtn.find('.consigne-ticket-qty').removeClass('disabled');
		}, true);
	};

	var updateShippingMode = function() {
		var url = '/action/epConsignePayment?ajax=true';
		url += '&shipping=' + $(this).val();

		ajax(url, function(response) {
			if (response.indexOf('success') !== -1) {
				updateRecap();
			}
		}, true);
	};

	var confirmOrder = function() {
		var t = $(this);
		var form = t.closest('form');
		
		formValidator.validateForm(form);

		if (!form.hasClass('has-error')) {
			t.addClass('disabled');
			form.submit();
		} else {
			t.closest('.popup').find('.popup-inner-close').trigger('click');
		}
	};
    
    var showTicketsDetail = function(){
        var t = $(this);
        var eventId = t.attr("data-eventid");
        var ticketId = t.attr("data-ticketid");
        var code = t.attr("data-code");
        
        var url = "/action/epFetchConsigneTickets";
        url += "?eventId="+eventId;
        url += "&ticketId="+ticketId;
        ajax(url, function(response, event){
            var json = JSON.parse(response.trim());
            $('#consigne-table-one-ticket-cat-popup-'+ticketId+' .one-participant-row:not(.clone)').remove();
			$.each(json, function(k, v) {
                var clone = $(".one-participant-row.clone").clone();
                
                clone.find(".ticket-number").html(json[k].index);
                clone.find(".ticket-code").html(json[k].qrCode);
                if(json[k].scannedIn){
                    clone.find(".toggle-ticket-activation-btn").remove();
                } else {
                    clone.find(".toggle-ticket-activation-btn").attr("data-id",json[k].id);
                    clone.find(".toggle-ticket-activation-btn").attr("data-eventid",eventId);
                    var active;
                    if(json[k].active){
                        clone.find(".scanned-ticket-text").remove();
                        active = false;
                    } else {
                        clone.find(".toggle-ticket-activation-btn .btn-placeholder").html(clone.find(".toggle-ticket-activation-btn").attr("data-activate"));
                        clone.addClass("inactive");
                        clone.find(".scanned-ticket-text").remove();    
                        active = true;                    
                    }
                    initToggleActive(event,clone.find(".toggle-ticket-activation-btn"), json[k].qrCode, active, eventId);
                }
                clone.removeClass("hide");
                clone.removeClass("clone");
                $('#consigne-table-one-ticket-cat-popup-'+ticketId+' .participants-list-table').append(clone);
			});

        }, true);
    };
	
    var initToggleActive = function(e, elmt, qr, active, eventId){
        elmt.click(function(){
            var url = "/action/epQR";
            url += "?qr="+qr;
            url += "&validate="+eventId;
            url += "&activate="+elmt.closest(".one-participant-row").hasClass("inactive");
            ajax(url, function(response){
                if(elmt.closest(".one-participant-row").hasClass("inactive")){
                    elmt.find(".btn-placeholder").html(elmt.attr("data-cancel"));
                } else {
                    elmt.find(".btn-placeholder").html(elmt.attr("data-activate"));                    
                }
                elmt.closest(".one-participant-row").toggleClass("inactive");
            }, true);            
        });
    };

    var printTickets = function() {
    	var t = $(this);
        var ctn = t.closest(".print-tickets-ctn");
        var from = ctn.find(".consigne-ticket-from").val();
        var to = ctn.find(".consigne-ticket-to").val();
    	var url = '/action/epPrintTickets';
    	url += '?ajax=true';
    	url += '&id=' + $(this).attr('id');
        
        if(from.trim() !== ''){
            url += '&from='+from;
        }
        if(to.trim() !== ''){
            url += '&to='+to;
        }
        
    	ajax(url, function(response){
    		if (response.indexOf('success') !== -1) {
    			t.closest('.popup-ctn').find('.popup-inner-close').trigger('click');
    		}
        }, true); 
    };

	var emptyCart = function() {
		ajax('/action/epAddCart?clear=true&ajax=true', function(response) {
			if (response.indexOf('success') !== -1) {
				cartRecap.find('.consignes-recap-items-ctn .consignes-recap-one-item').remove();
				updateRecap();
				$('.items-from-other-page-in-cart').slideUp();
			}
		}, true);
	};
    
	var init = function () {
		formAnimate = Fw.component.models().formAnimate;
		formValidator = Fw.component.models().form;
		tools = Fw.component.models().tools;
		win = $(window);
		formBtn = $('.add-new-item-btn.consigne');
		formCtn = $('.create-consignes-form-ctn');
		consignesRecapCtn = $('.consignes-recap-outer-ctn.invisible');
		consignesRecapOuterCtn = $('.consignes-tab-1-recap-ctn');
		showTicketCatsBtn = $('.show-ticket-cats');
		showTicketCatsBtnResp = $('.consigne-table-ticket-cats-btn-resp');
		ticketChoiceCheck = $('.consignes-tickets-box .package-ticket-choice');
		cartRecap = $('.consignes-recap-ctn');
		consignesQtyCtn = $('.consignes-qty-tickets-outer-ctn');
		deleteTicketChoiceBtn = $('.delete-btn', consignesQtyCtn);
		qtyInput = $('.form-input', consignesQtyCtn);
		shippingMode = $('.consignes-delivery-mode');
		confirmOrderBtn = $('.consignes-recap-confirm-order-btn');
		showTicketsDetailBtn = $('.show-tickets');
		printConsigneTicketsBtn = $('.print-consigne-tickets-btn');

		deleteTicketChoiceBtn.click(deleteTicket);
		qtyInput.keyup(checkQtyMax);
		qtyInput.focusout(updateQty);
		shippingMode.click(updateShippingMode);
		confirmOrderBtn.click(confirmOrder);
        showTicketsDetailBtn.click(showTicketsDetail);
        printConsigneTicketsBtn.click(printTickets);
        $('.add-new-item-btn.consigne.js-empty-cart').click(emptyCart);

		formBtn.click(function() {
			setTimeout(function() {
				if (formCtn.hasClass('open')) {
					checkScroll();

					win.scroll(function() {
						checkScroll();
					});
					win.resize(function() {
						checkScroll();
					});
				}
			}, 500);
		});

		showTicketCatsBtn.click(showTicketCats);
		ticketChoiceCheck.change(ticketToQtyBox);

		if (cartRecap.length) {
			updateRecap();
		}
	};
	
	$(window).on('load',function(){
		init();
	});
	
})(jQuery);
